import React from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Segment, Header, Icon } from "semantic-ui-react";
import Immersive3dTour from "~/models/Immersive3dTour/Immersive3dTour";

/**
 * Shown instead of "we are processing" while the processing job is failed for lack of credits.
 * Buying credits requeues the job, and the page polls, so this goes away on its own afterwards.
 */
function WaitingForCreditsSection({ immersive3dTour, processingRequestDts }) {
  const { requiredCredits, missingCredits, stage } = immersive3dTour.waitingForCredits;
  const step = stage === "delivery" ? "delivered" : "processed";

  return (
    <Segment placeholder className="waiting-for-credits">
      <Header icon>
        <Icon name="clock outline" />
        Your Immersive 3D Tour is waiting for credits
      </Header>
      <Segment.Inline>
        <p>It was sent to processing at {processingRequestDts}, but your account did not have enough credits.</p>
        <p>
          {requiredCredits !== null
            ? `It needs ${requiredCredits} credits to be ${step}. `
            : `Your balance is too low for it to be ${step}. `}
          {missingCredits > 0
            ? `You need at least ${missingCredits} more credit${missingCredits > 1 ? "s" : ""}.`
            : "Your balance now covers it and processing will resume automatically within a few minutes."}
        </p>
        {missingCredits > 0 && (
          <a href="/panel/credits/billing" target="_blank" rel="noopener noreferrer" className="ui button primary">
            <Icon name="external" />
            Purchase credits
          </a>
        )}
        <p style={{ marginTop: "1em" }}>Processing resumes automatically once your purchase is complete.</p>
      </Segment.Inline>
    </Segment>
  );
}

WaitingForCreditsSection.propTypes = {
  immersive3dTour: PropTypes.instanceOf(Immersive3dTour).isRequired,
  processingRequestDts: PropTypes.string.isRequired,
};

export default observer(WaitingForCreditsSection);
